<template>
      <div id="wrapper">

            <topbar></topbar>
            <left></left>
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">

                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">认证专区</h4>

                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                <li class="breadcrumb-item active">首次认证</li>
                                          </ol>

                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->


                        <div class="row">
                              <div class="col-12">
                                    <div class="card-box">
                                          <h4 class="m-t-0 header-title" style="border-bottom: 1px solid #868686;padding-bottom: 10px;"><b style="font-size: 16px;margin-bottom: 10px;">认证费用</b></h4>
                                          <p class="text-muted m-b-30 font-14" style="color: #000000 !important;line-height: 30px;margin-top:17px;margin-bottom: 20px;">
                                                认证审核已通过，请完成认证费用支付<br/>
                                                认证费用：<code style="font-size:18px !important; font-weight: bold">{{money}}元</code>
                                          </p>
                                          <div class="row">
                                                <div class="col-12">
                                                      <div class="p-20">


                                                            <div class="form-group row">

                                                                  <div class="col-10">

                                                                        <div style="width:50%;float:left;">

                                                                              <img src="images/260.jpg">
                                                                        </div>



                                                                  </div>
                                                            </div>

                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  您需要支付的费用为: <code style="font-size:16px !important; font-weight: bold">{{money}}元</code>
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  请选择付款方式
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                                  <img src="/member2/images/alipay.png" width="200px"  v-on:click="baoming('alipay')">
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                                  <img src="/member2/images/wechatpay.png" width="200px"   v-on:click="baoming('wechatpay')">
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  或者使用兑换码
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                                  <input type="text" name="country"
                                                                         v-model="code"
                                                                         class="form-control"
                                                                         placeholder="请输入兑换码"
                                                                         style="max-width: 410px;margin-top: 10px;"
                                                                  >
                                                            </p>
                                                            <p  class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  <button type="submit" style="margin: 0 auto;"
                                                                          class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                                          v-on:click="freecode">提交兑换码
                                                                  </button>
                                                            </p>





                                                            <div style="clear: both"></div>


                                                      </div>
                                                </div>

                                          </div>
                                          <!-- end row -->

                                    </div> <!-- end card-box -->
                              </div><!-- end col -->
                        </div>
                        <!-- end row -->


                  </div> <!-- container -->

            </div> <!-- content -->

            <!--footer-->

      </div>

      </div>
</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                        id:this.$route.query.id,
                        paystyle: this.paystyle,
                        money: 280.00,
                        code:this.code,
                  }
            },
            mounted(){
            },
            methods: {
                  baoming: function (paystyle) {

                        this.paystyle=paystyle;
                        let data = {
                              id:this.id,
                              money: this.money,
                              paystyle: this.paystyle,
                        }
                        this.$axios({
                              method: "POST",
                              url: '/api/member2/rz_pay',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if (response.data.code === 0) {
                                    // 0-alipay wechatpay
                                    if (response.data.arr.paystyle === 'alipay') {
                                          console.log(response.data.arr.paystyle);
                                          window.location.href = '/api/member2/pay/rz_alipay/' + response.data.arr.orderid;
                                    } else if (response.data.arr.paystyle === 'wechatpay') {
                                          if (this.isMobile()) {
                                                this.wechatpay_h5(response.data.arr.orderid);
                                          } else {
                                                //this.wechatpay(response.data.arr.orderid);
                                                window.location.href="/member2/#/Authentication_wechatpay_erweima/"+response.data.arr.orderid;
                                          }
                                          //this.isMobile();

                                    }


                              } else {
                                    alert(response.data.msg);
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  isMobile: function () {
                        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                        console.log(flag);
                        return flag;
                  },
                  youknow: function () {
                        alert('报考须知\n' +
                              '1.考试费为单次考试费用，考试未通过需重新支付考试费参加考试；\n' +
                              '\n' +
                              '2.考试成绩有效期为2年，考试通过后2年内可提交认证申请；\n' +
                              '\n' +
                              '3.考试通过后，须满足认证条件，方可进行认证申请，须支付认证费200元； \n' +
                              '\n' +
                              '4.通过认证后，须持续接受继续教育，并满足相应条件，方可申请续会流程；\n' +
                              '\n' +
                              '5.考试日前45天内，考试费用不可退。考试日45天之前可申请退还考试费，但须扣除200元手续费；\n' +
                              '\n' +
                              '6.报考事宜须符合认证标准指导委员会的规定。\n' +
                              '\n' +
                              '附：“特许私人财富管理师（CPWM）”资格认证要求2年以上（含2年）财富管理相关机构（银行、证券、保险、信托、基金、第三方财富等）或专业机构（律师事务所、会计事务所等）工作经验，且认证前一年度税前收入不低于30万元人民币（以税单或机构证明为准）。')
                  },

                  wechatpay_h5: function (orderid) {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/pay/rz_wechatpay_h5/' + orderid
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = response.data.mweburl;
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  },
                  freecode:function () {
                        let data = {
                              id:this.id,
                              code:this.code,
                              money: 0,
                              paystyle: 'freecode',
                        }
                        this.$axios({
                              method: 'post',
                              data:data,
                              url: '/api/member2/pay/freecode/',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = '/member2/#/Authentication_fapiao?out_trade_no='+this.code;
                              }else{
                                    //alert(response.data.msg);
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  }


                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}



</style>



// WEBPACK FOOTER //
// src/components/Authentication_pay.vue